exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tabs-top .tab-item[_v-e15ac080]{margin-top:1px}.tabs-bottom .tab-item[_v-e15ac080]{margin-top:0}.tabs-top>.tabs[_v-e15ac080]{border-bottom:1px solid #ddd}@media only screen and (-webkit-min-device-pixel-ratio:2){.tabs-top>.tabs[_v-e15ac080]{border-bottom:.5px solid #ddd}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-e15ac080&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/tabs/index.vue
// module id = 193
// module chunks = 0